import { render, staticRenderFns } from "./UpsellRules.vue?vue&type=template&id=d64ac0f2&scoped=true"
import script from "./UpsellRules.vue?vue&type=script&lang=js"
export * from "./UpsellRules.vue?vue&type=script&lang=js"
import style0 from "./UpsellRules.vue?vue&type=style&index=0&id=d64ac0f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64ac0f2",
  null
  
)

export default component.exports